import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { api, ApiError } from "../lib/api";

/**
 * Ziel des Links aus DEVONthink (Feld „Quittungs-App_Q“): /receipts/by-dt/<DEVONthink-UUID>.
 * Leitet zum Beleg weiter oder sagt freundlich, dass er noch nicht angekommen ist (Übergabe läuft ggf. noch).
 */
export function ByDtPage() {
  const { uuid } = useParams();
  const [ziel, setZiel] = useState<string | null>(null);
  const [fehlt, setFehlt] = useState<number | null>(null);
  useEffect(() => {
    api.get<{ receipt_id: string }>(`/api/receipts/by-dt/${encodeURIComponent(uuid ?? "")}`)
      .then((r) => setZiel(r.receipt_id))
      .catch((e: unknown) => setFehlt(e instanceof ApiError ? e.status : 0));
  }, [uuid]);
  if (ziel) return <Navigate to={`/receipts/${ziel}`} replace />;
  if (fehlt !== null) {
    const [titel, text] =
      fehlt === 410 ? ["Beleg in der App gelöscht", "Dieser Beleg liegt in DEVONthink, wurde in der Quittungs-App aber gelöscht."]
      : fehlt === 400 ? ["Link ungültig", "Der Link aus DEVONthink enthält keine gültige Kennung."]
      : fehlt === 404 ? ["Beleg noch nicht in der App", "Dieser Beleg liegt in DEVONthink, ist aber (noch) nicht in der Quittungs-App angekommen. Die Übergabe vom Mac läuft automatisch; bitte später noch einmal öffnen."]
      : ["Beleg konnte nicht geladen werden", "Die App ist gerade nicht erreichbar. Bitte später noch einmal öffnen."];
    return (
      <div className="max-w-xl mx-auto p-6">
        <div className="bg-white rounded-iosLg shadow-card p-5">
          <h1 className="text-[17px] font-semibold mb-2">{titel}</h1>
          <p className="text-[14px] text-ios-muted">{text}</p>
          <Link to="/inbox" className="inline-block mt-4 text-ios-blue text-[14px]">Zur Inbox</Link>
        </div>
      </div>
    );
  }
  return <div className="p-6 text-[14px] text-ios-muted">Beleg wird gesucht …</div>;
}
